import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const pinDefaultVariants = {
  "placement": "top-right"
}
const pinCompoundVariants = []

const pinSlotNames = [
  [
    "root",
    "Pin__root"
  ],
  [
    "top-left",
    "Pin__top-left"
  ],
  [
    "top-right",
    "Pin__top-right"
  ],
  [
    "bottom-left",
    "Pin__bottom-left"
  ],
  [
    "bottom-right",
    "Pin__bottom-right"
  ]
]
const pinSlotFns = /* @__PURE__ */ pinSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, pinDefaultVariants, getSlotCompoundVariant(pinCompoundVariants, slotName))])

const pinFn = memo((props = {}) => {
  return Object.fromEntries(pinSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const pinVariantKeys = [
  "placement"
]
const getVariantProps = (variants) => ({ ...pinDefaultVariants, ...compact(variants) })

export const pin = /* @__PURE__ */ Object.assign(pinFn, {
  __recipe__: false,
  __name__: 'pin',
  raw: (props) => props,
  variantKeys: pinVariantKeys,
  variantMap: {
  "placement": [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, pinVariantKeys)
  },
  getVariantProps
})